// src/components/demos/VertexSearchDemo.tsx
import React from 'react';
import { Alert } from '@/components/markdown/Alert';
import { Search, Database } from 'lucide-react';

const VertexSearchDemo = () => {
  const configId = "c09df02f-06e3-4285-b62f-823dcb95407d";
  
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm">
        <Search className="h-4 w-4"/>
        <div className="flex-1 truncate bg-muted px-2 py-1 rounded">
          Vertex AI Search
        </div>
      </div>
      
      <div className="border rounded-lg p-3">
        <div className="flex items-center gap-2 mb-2">
          <Database className="h-4 w-4 text-blue-500" />
          <div className="font-medium text-sm">Knowledge Base ID:</div>
        </div>
        
        <div className="text-xs font-mono bg-muted p-2 rounded mb-3 break-all">
          {configId}
        </div>
        
        {/* Mock search input */}
        <div className="w-full p-2 border border-gray-300 rounded text-sm bg-white mt-3">
          Search knowledge base...
        </div>
      </div>
      
      <div className="border rounded-lg p-3 space-y-2">
        <div className="font-medium text-sm">Sample Results:</div>
        <div className="text-xs space-y-2">
          <div className="p-2 bg-muted/30 rounded">
            <div className="font-medium">User Guide: Getting Started</div>
            <div className="text-muted-foreground mt-1">
              Learn how to set up your environment and configure authentication...
            </div>
          </div>
          
          <div className="p-2 bg-muted/30 rounded">
            <div className="font-medium">API Reference: Authentication</div>
            <div className="text-muted-foreground mt-1">
              Complete guide to OAuth2 authentication methods and token...
            </div>
          </div>
        </div>
      </div>
      
      <Alert>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"/>
          <span>Search system ready</span>
        </div>
      </Alert>
    </div>
  );
};

export default VertexSearchDemo;